import moneyComboBook from 'assets/images/moneyCombo.jpg';

import {
  ONLY_PURCHASE,
  LOGIN,
  ADDRESS,
  PAYMENT,
  THANKS,
  PASSWORD,
  FIRST_NAME,
  LAST_NAME,
  ZIP_CODE,
  CITY,
  COUNTRY,
  EMAIL,
  GIFT_BOOK,
  SMART_BOOKS,
  ACCOUNT_BOOK,
} from '../const';

const moneyCombo2 = {
  book: {
    id: 'money-combo-2',
    format: SMART_BOOKS,
    title: 'Money-Combo-2',
    subtitle: 'Voucher for a Premium annual subscription',
    price: [100],
    introductions: [
      {
        type: 'textWithList',
        text: 'With the Fintool Money Combo, you receive',
        list: ['an annual subscription to Fintool-Premium worth CHF 100', 'the latest book Switzerland takes care'],
      },
      'The combo worth CHF 143',
    ],
    image: moneyComboBook,
  },
  bookIds: [33],
  getDefaultOption: ({ isPremium, isBasic }) => (isBasic && 1) || (!isPremium && 2) || 0,
  getDefaultStrictMode: ({ isPremium, isBasic }) => Boolean(isBasic || isPremium),
  orderOptions: [ACCOUNT_BOOK, GIFT_BOOK],
  purchases: [
    {
      id: 1,
      name: 'Fintool Premium Subscriber',
      tasks: {
        [LOGIN]: () => ({
          banner: {
            title: 'Fintool Premium Subscriber',
            price: 'PriceCHF/insteadCHF',
            priceValues: [100, 143],
            propositions: ['Printed book', '12 months Fintool-Premium'],
          },
          form: {
            showSubscribeDescription: false,
            inputs: [EMAIL, PASSWORD],
            submitButton: 'Login',
            showAdb: false,
          },
          nextStep: 1,
        }),
        [ADDRESS]: () => ({
          banner: {
            title: 'Fintool Premium Subscriber',
            price: 'PriceCHF/insteadCHF',
            priceValues: [100, 143],
            propositions: ['Printed book', '12 months Fintool-Premium'],
          },
          form: {
            showSubscribeDescription: false,
            inputs: [ADDRESS, ZIP_CODE, CITY, COUNTRY],
            submitButton: 'Continue',
            showAdb: false,
          },
          navigation: '1/2',
          nextStep: 2,
        }),
        [PAYMENT]: () => ({
          banner: {
            title: 'Fintool Premium Subscriber',
            price: 'PriceCHF/insteadCHF',
            priceValues: [100, 143],
            propositions: ['Printed book', '12 months Fintool-Premium'],
          },
          form: { withPromoCode: false },
          navigation: '2/2',
          prevStep: 1,
          nextStep: 3,
          shouldSignUp: false,
          subscribeId: null,
          productId: 33,
        }),
        [THANKS]: () => ({
          form: {
            title: 'Your order is on its way',
            description:
              'Thank you for your order. The book is on its way to you. Take advantage of the Fintool Premium offer and expand your money knowledge in one of our courses.',
            button: { name: 'To the Fintool Academy', url: '/akademie' },
          },
        }),
      },
    },
    {
      id: 2,
      name: 'Fintool Basic subscriber',
      tasks: {
        [LOGIN]: () => ({
          banner: {
            title: 'Fintool Basic subscriber',
            price: 'PriceCHF/insteadCHF',
            priceValues: [100, 143],
            propositions: ['Printed book', '12 months Fintool-Premium'],
          },
          form: {
            showSubscribeDescription: false,
            inputs: [EMAIL, PASSWORD],
            submitButton: 'Login',
            showAdb: false,
          },
          nextStep: 1,
        }),
        [ADDRESS]: () => ({
          banner: {
            title: 'Fintool Basic subscriber',
            price: 'PriceCHF/insteadCHF',
            priceValues: [100, 143],
            propositions: ['Printed book', '12 months Fintool-Premium'],
          },
          form: {
            showSubscribeDescription: false,
            inputs: [ADDRESS, ZIP_CODE, CITY, COUNTRY],
            submitButton: 'Continue',
            showAdb: false,
          },
          navigation: '1/2',
          nextStep: 2,
        }),
        [PAYMENT]: () => ({
          banner: {
            title: 'Fintool Basic subscriber',
            price: 'PriceCHF/insteadCHF',
            priceValues: [100, 143],
            propositions: ['Printed book', '12 months Fintool-Premium'],
          },
          form: { withPromoCode: false },
          navigation: '2/2',
          prevStep: 1,
          nextStep: 3,
          shouldSignUp: false,
          subscribeId: null,
          productId: 33,
        }),
        [THANKS]: () => ({
          form: {
            title: 'Your order is on its way',
            description:
              'Thank you for your order. The book is on its way to you. Take advantage of the Fintool Premium offer and expand your money knowledge in one of our courses.',
            button: { name: 'To the Fintool Academy', url: '/akademie' },
          },
        }),
      },
    },
    {
      id: 3,
      name: 'No subscription',
      tasks: {
        [ONLY_PURCHASE]: () => ({
          banner: {
            title: 'Not a Fintool subscriber',
            price: 'PriceCHF/insteadCHF',
            priceValues: [100, 143],
            propositions: ['Printed book', '12 months Fintool-Premium'],
          },
          form: {
            showSubscribeDescription: false,
            inputs: [FIRST_NAME, LAST_NAME, ADDRESS, ZIP_CODE, CITY, COUNTRY, EMAIL],
            submitButton: 'Continue',
            showAdb: false,
          },
          navigation: '1/2',
          nextStep: 1,
        }),
        [PAYMENT]: () => ({
          banner: {
            title: 'Not a Fintool subscriber',
            price: 'PriceCHF/insteadCHF',
            priceValues: [100, 143],
            propositions: ['Printed book', '12 months Fintool-Premium'],
          },
          form: { withPromoCode: false },
          navigation: '2/2',
          prevStep: 0,
          nextStep: 2,
          shouldSignUp: false,
          subscribeId: null,
          productId: 33,
        }),
        [THANKS]: () => ({
          form: {
            title: 'Your order is on its way',
            description:
              'Thank you for your order. The book is on its way to you. Take advantage of the Fintool Premium offer and expand your money knowledge in one of our courses.',
            button: { name: 'To the video studio', url: '/videos' },
          },
        }),
      },
    },
  ],
};

export default moneyCombo2;
